import { useEffect } from 'react';
import { DataSourcesQueries } from '@frontend/api-data-sources';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { getTodaysDate } from '@frontend/date';
import { useCalendarLocationIds } from '../../stores/calendar-location.store';
import { useOnboardingFlowInfo } from './use-onboarding-flow-info';

export const useShouldShowOnboardingFlow = () => {
  const { calendarLocationIds } = useCalendarLocationIds();
  const { isScheduleV3FlagEnabled } = SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();
  const { isIntegratedOffice, isLoading: isLoadingIntegrations } = DataSourcesQueries.useGetAccessibleIntegrations();
  const { isDataFetched: isOnboardingInfoFetched, onboardingFlowInfo, setOnboardingFlowInfo } = useOnboardingFlowInfo();

  const { isLoading, isError, data } = SchedulerV3.Helpers.useGetCalendarEventsV3Data({
    selectedLocationIds: calendarLocationIds,
    selectedDate: getTodaysDate('MM/DD/YYYY'),
    page: 1,
    limit: 1,
    includeAttendeeDetails: false,
    isOnboardingFlow: true,
    enabled:
      isOnboardingInfoFetched &&
      (!onboardingFlowInfo.status || ['not_started', 'in_progress'].includes(onboardingFlowInfo.status)),
  });

  const totalEvents = Number(data?.totalCount) || 0;
  const hasEvents = totalEvents > 0;
  const isDataLoaded = !isLoading && !isError && calendarLocationIds.length > 0;
  const shouldShowOnboardingFlow =
    isDataLoaded && !hasEvents && isScheduleV3FlagEnabled && !isLoadingIntegrations && !isIntegratedOffice && false; // NOTE: disabling this as we need to update onboarding flow for new schedule definication configuration case.

  // set onboarding flow status as not_required if user has events and onboarding flow is not completed
  useEffect(() => {
    if (
      isDataLoaded &&
      isOnboardingInfoFetched &&
      !shouldShowOnboardingFlow &&
      (onboardingFlowInfo.status === 'not_started' || onboardingFlowInfo.status === 'in_progress')
    ) {
      setOnboardingFlowInfo({ status: 'not_required' });
    }
  }, [shouldShowOnboardingFlow, isDataLoaded, isOnboardingInfoFetched]);

  return { shouldShowOnboardingFlow };
};
